module.exports = __webpack_public_path__ + "media/flags/bb-ce819093.svg";